import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './config';

//sentry imports
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

if (config.environment != 'local') {
  Sentry.init({
    dsn: config.sentryDSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: config.tracesSampleRate,
  });
}

const params = new URL(document.location).searchParams;

window.heap.load(config.heapProductID);
window.heap.identify(params?.user_id);
window.heap.addUserProperties(params);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
